export const PUBLIC_PROFILE_STATUSES = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
}

export const USER_ROLES = {
    BUSINESS: 'BUSINESS',
    EDUCATION: 'EDUCATION',
}
